import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { AppInitializerService } from '@app/app-initializer.service';
import { ApiService as ResourceApiService } from '@app/modules/resource/utilities/services/api.service';
import { BaseService } from '@app/system/services/base.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Component({
	selector: 'app-playlist-panel',
	templateUrl: './playlist-panel.component.html',
	styleUrls: ['./playlist-panel.component.scss']
})
export class PlaylistPanelComponent implements OnInit, OnChanges {

	@Input() actionType;
	@Input() playlistData: any = [];
	@Input() playlistParentData;
	@Output() pageActions: any = new EventEmitter();

	progressCount = 0;
	title = '';
	selectedIndex;
	closeTemplate = false;
	opened = false;
	showQueues = false;

	constructor(
		private appInit: AppInitializerService,
		private resourceApiService: ResourceApiService,
		private gfService: GlobalFunctionService,
		private baseService: BaseService
	) { }

	ngOnInit(): void {
		// this.gfService.resourceDetailScroll = false;
		this.playlistData.map((resp, index) => {
			if (resp.streaming && !this.title) {
				this.title = resp.title;
				this.selectedIndex = index;
			}
		});
	}

	ngOnChanges(changes) {
		const type = changes?.actionType?.currentValue?.type;
		if (changes && changes.playlistData && changes.playlistData.currentValue) {
			let count = 0;
			let percentageFindCount = 0;
			changes.playlistData.currentValue.forEach((play: any) => {
				if (play.watched) {
					count += 1;
					if (play.changed) {
						percentageFindCount += 1;
					}
				}
			});
			this.progressCount = (count / changes.playlistData.currentValue.length) * 100;
			if (percentageFindCount) {
				this.markAsPlaylistRead();
			}
		}
		if (type) {
			if (this.selectedIndex !== 0 && type === 'previous') {
				this.playlistData[this.selectedIndex].streaming = false;
				this.selectedIndex -= 1;
				this.playlistData[this.selectedIndex].streaming = true;
				this.getPlayList({ selectedData: this.playlistData[this.selectedIndex], selectedIndex: this.selectedIndex }, true);
			} else if (this.selectedIndex !== (this.playlistData.length - 1) && type === 'next') {
				this.playlistData[this.selectedIndex].streaming = false;
				this.selectedIndex += 1;
				this.playlistData[this.selectedIndex].streaming = true;
				this.getPlayList({ selectedData: this.playlistData[this.selectedIndex], selectedIndex: this.selectedIndex }, true);
			}
		}
	}

	markAsPlaylistRead() {
		if (!this.playlistParentData.read) {
			const apiData = {
				type: 1,
				completedPercent: this.progressCount
			};
			const headers: any = {};
			this.resourceApiService.addReadLog(apiData, this.playlistParentData.resourceID, headers).subscribe(
				(response) => {
					this.playlistParentData.read = response.read;
					this.playlistParentData.completedPercent = this.progressCount;
					if (response.read) {
						this.baseService.logUserActivity('read', 'learning', [''], { resourceData: this.playlistParentData });
					}
				},
				(error) => { }
			)
				.add(() => { });
		}
	}

	isOpen(status) {
		this.opened = status;
		this.closeTemplate = false;
	}

	getPlayList(data, state?) {
		if (navigator.onLine) {
			this.closeTemplate = true;
			this.opened = false;
			this.showQueues = false;
			if (state || data.selectedData.resourceID !== this.playlistData[this.selectedIndex].resourceID) {
				this.title = data.selectedData.title;
				const actionBtns = {
					prevBtn: false,
					nextBtn: false
				};
				// if (data.selectedIndex === 0) {
				// 	actionBtns.prevBtn = false;
				// } else if (data.selectedIndex === (this.playlistData.length - 1)) {
				// 	actionBtns.nextBtn = false;
				// }
				if (data.selectedIndex === 0) {
					actionBtns.prevBtn = true;
				} else if (data.selectedIndex === (this.playlistData.length - 1)) {
					actionBtns.nextBtn = true;
				}
				this.selectedIndex = data.selectedIndex;
				this.pageActions.emit({
					actionBtns,
					data: data.selectedData,
					selectedIndex: data.selectedIndex
				});
			}
		}
	}
}
